module.exports = "<div class=\"button\" [formGroup]=\"parent\">\n  <button mat-raised-button\n          color=\"accent\"\n          type=\"button\"\n          (click)=\"onClick()\"\n          [disabled]=\"parent.invalid || parent.disabled\">\n    <ng-content></ng-content>\n  </button>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/button/button.component.html
// module id = ./src/app/shared/button/button.component.html
// module chunks = main